module.exports = __webpack_public_path__ + "static/img/download_andrid.ea20501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_andrid.png
// module id = mO8z
// module chunks = 1